<script>
export default {
    name: "IconUserInShot"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 44" fill="none">
        <path
            d="M37.655 30.25V34.9643C37.655 35.5894 37.4066 36.1891 36.9646 36.631C36.5227 37.073 35.923 37.3214 35.2979 37.3214H30.5836"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M30.5836 6.67847H35.2979C35.923 6.67847 36.5227 6.92681 36.9646 7.36886C37.4066 7.81091 37.655 8.41045 37.655 9.03561V13.7499"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M7.01221 13.7499V9.03561C7.01221 8.41045 7.26055 7.81091 7.7026 7.36886C8.14465 6.92681 8.74419 6.67847 9.36935 6.67847H14.0836"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M14.0836 37.3214H9.36935C8.74419 37.3214 8.14465 37.073 7.7026 36.631C7.26055 36.1891 7.01221 35.5894 7.01221 34.9643V30.25"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M22.3341 20.2977C24.3592 20.2977 26.0008 18.6561 26.0008 16.631C26.0008 14.606 24.3592 12.9644 22.3341 12.9644C20.3091 12.9644 18.6675 14.606 18.6675 16.631C18.6675 18.6561 20.3091 20.2977 22.3341 20.2977Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M26.7259 25.0678C28.0108 25.87 28.9649 27.0007 29.4506 28.2971C29.9364 29.5935 29.4506 31.1666 29.4506 31.1666H15.1515C15.1515 31.1666 14.8103 29.3811 15.1515 28.2971C15.6208 26.8063 16.5913 25.87 17.8762 25.0678C19.1612 24.2655 20.7106 23.8333 22.3011 23.8333C23.8915 23.8333 25.441 24.2655 26.7259 25.0678Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
